"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInfectiousDiseaseTestOrderDto = instanceOfInfectiousDiseaseTestOrderDto;
exports.InfectiousDiseaseTestOrderDtoFromJSON = InfectiousDiseaseTestOrderDtoFromJSON;
exports.InfectiousDiseaseTestOrderDtoFromJSONTyped = InfectiousDiseaseTestOrderDtoFromJSONTyped;
exports.InfectiousDiseaseTestOrderDtoToJSON = InfectiousDiseaseTestOrderDtoToJSON;
exports.InfectiousDiseaseTestOrderDtoToJSONTyped = InfectiousDiseaseTestOrderDtoToJSONTyped;
const InfectiousDiseaseTestType_1 = require("./InfectiousDiseaseTestType");
/**
 * Check if a given object implements the InfectiousDiseaseTestOrderDto interface.
 */
function instanceOfInfectiousDiseaseTestOrderDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('orderedAt' in value) || value['orderedAt'] === undefined)
        return false;
    if (!('orderedBy' in value) || value['orderedBy'] === undefined)
        return false;
    return true;
}
function InfectiousDiseaseTestOrderDtoFromJSON(json) {
    return InfectiousDiseaseTestOrderDtoFromJSONTyped(json, false);
}
function InfectiousDiseaseTestOrderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeFromJSON)(json['code']),
        'createdAt': (new Date(json['createdAt'])),
        'orderedAt': (json['orderedAt'] == null ? null : new Date(json['orderedAt'])),
        'orderedBy': json['orderedBy'],
    };
}
function InfectiousDiseaseTestOrderDtoToJSON(json) {
    return InfectiousDiseaseTestOrderDtoToJSONTyped(json, false);
}
function InfectiousDiseaseTestOrderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeToJSON)(value['code']),
        'createdAt': ((value['createdAt']).toISOString()),
        'orderedAt': (value['orderedAt'] == null ? null : value['orderedAt'].toISOString()),
        'orderedBy': value['orderedBy'],
    };
}
//# sourceMappingURL=InfectiousDiseaseTestOrderDto.js.map